export interface AnalyticsConfig {
  attributionWindowDays: number;
  // Local Storage Keys
  visitorIdKey: string;
  sessionIdKey: string;
  originalGclidKey: string;
  originalGclidExpiry: string;
  
  engagementTimeoutMilliSec: number;
  engagementScrollThreshold: number;

  // Firestore Collections
  collections: {
    sessions: string;
    minimalSessions: string;
    events: string;
    googleAdsAttribution: string;
  };
}

export const ANALYTICS_CONFIG: AnalyticsConfig = {
  attributionWindowDays: 14,
  
  // Local Storage Keys
  visitorIdKey: 'visitor_id',
  sessionIdKey: 'current_session_id',
  originalGclidKey: 'original_gclid',
  originalGclidExpiry: 'original_gclid_expiry',

  engagementTimeoutMilliSec: 10000,
  engagementScrollThreshold: 25,
  
  // Firestore Collections
  collections: {
    sessions: 'sessions',
    minimalSessions: 'minimal-sessions', // Optional for backward compatibility
    events: 'events', 
    googleAdsAttribution: 'ads-attribution'
  }
};
